import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

/*Import Styles*/
import './styles/css/app.scss';

/*Import Files Redux*/
import {Provider} from "react-redux";
import configureStore from "./redux/store";
import {PersistGate} from 'redux-persist/integration/react';

const {store, persistor} = configureStore();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


root.render(
	<Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <App/>
        </PersistGate>
    </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
